import { getRouteApi } from '@tanstack/react-router';

export const searchRouteApi = getRouteApi('/');
